











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import DropDownMenu from '@/components/Tailwind/DropDownMenu.vue';

@Component({
  components: {
    DropDownMenu,
  },
  methods: {
    ...mapActions(['setPageLanguage']),
  },
  computed: {
    ...mapGetters(['pageLanguage']),
  },
})
export default class Languages extends Vue {
  private isOpen: boolean = false;

  private created() {
    const handleEscape = (e: {key: string}) => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.isOpen = false;
      }
    };

    document.addEventListener('keydown', handleEscape);

    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleEscape);
    });
  }
}
